export const REPOS = [
    "pgiffy/peter-lee-gifford.com",
    "pgiffy/sass-ideate",
    "pgiffy/easy-degen",
    "pgiffy/kergis"
];
